export const OrderSortBy = {
  id: "מס' הזמנה",
  domain: 'דומיין',
  status: 'סטטוס'
};

export const OrderStatus = {
  pending: 'pending',
  completed: 'completed',
  canceled: 'canceled',
};

export const SortOrder = {
  ASC: 'asc',
  DESC: 'desc',
};
